import { createAction } from '@reduxjs/toolkit';
const prefix = 'settings/messenger/knowledge';
export const messengerSettingsActions = {
    toggleElevioIntegration: createAction(`${prefix}/toggleElevioIntegration`),
    updateDisplayType: createAction(`${prefix}/updateDisplayType`),
    changeSelectedLanguage: createAction(`${prefix}/changeSelectedLanguage`),
    updateTranslatedString: createAction(`${prefix}/updateTranslatedString`),
    setElevioCompanyId: createAction(`${prefix}/setElevioCompanyId`),
    initialize: createAction(`${prefix}/initialize`),
    reset: createAction(`${prefix}/reset`),
};
